import { createContext } from 'react';

import { emptyModalProviderValue } from '@trqk/components';

// We create the initial context with placeholders so that its type matches the eventual value.
export const ModalContext = createContext<ModalProviderValue>(
    emptyModalProviderValue,
);
